import React from "react";
import PropTypes from 'prop-types';

import _ from 'lodash';
import EnhancedSwitch from 'react-icheck/lib/EnhancedSwitch'
import { Checkbox } from "react-icheck";

import Grid from "../../../layout/grid/grid";
import Row from "../../../layout/grid/row";

import "icheck/skins/all.css";

// Workaround for https://github.com/luqin/react-icheck/issues/43
EnhancedSwitch.propTypes = {
    ...EnhancedSwitch.propTypes,
    cursor: PropTypes.any,
    checked: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
}

export class CheckboxLabel extends React.PureComponent {
	componentDidMount = () => {
		const { input } = this.props;

		if (_.isEmpty(input.value)) {
			input.onChange(false);
		}
	}

	render() {
		const {
			option, input, labelStyle, meta: { touched, error }, disabled
		} = this.props;
		return (
			<Grid cols={this.props.cols}>
				<div
					className={`form-group ${touched && error && "has-error"}`}
				>
					<Row style={{
                        marginLeft: 0, display: 'flex', flex: 1,
                        justifyContent: 'center',
                        alignContent: 'center',
                        alignItems: 'center',
                    }}>
						<Checkbox
							checkboxClass="icheckbox_square-blue"
							name={input.name}
							value={option.value}
							cursor={'false'}
							checked={input.value}
							onChange={event =>
								input.onChange(!event.target.checked)
							}
							disabled={disabled}
						/>
						&nbsp;&nbsp;
						<label htmlFor={option.label} style={labelStyle}>
							{option.label}
						</label>
					</Row>
				</div>
			</Grid>
		);
	}
}